module.exports = __webpack_public_path__ + "img/illusCorona3.32a0c313.jpg";